module.exports = __webpack_public_path__ + "img/drop-icon.2e0ecece.svg";